import { render, staticRenderFns } from "./forget.vue?vue&type=template&id=43453021&scoped=true&"
import script from "./forget.vue?vue&type=script&lang=js&"
export * from "./forget.vue?vue&type=script&lang=js&"
import style0 from "./forget.vue?vue&type=style&index=0&id=43453021&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43453021",
  null
  
)

export default component.exports